export default __webpack_public_path__ + "static/media/bg_3.d20a4f51.webp";